import api from '../../api/_inventaire'


const state = () => ({
    inventaires: [],
    inventaire: {},
    resultats: [],
})

// getters
const getters = {
    inventaires: (state) => {
        return state.inventaires
    },

    inventaire: (state) => {
        return state.inventaire
    },

    resultats: (state) => {
        return state.resultats
    },
}

// actions
const actions = {

    /**
     * Liste des articles
     */
     getInventaire({commit}, id) {
        api.getInventaire(id).then(
            response => {
                commit('SET_INVENTAIRE', response)
            }
        )
    },
    

    /**
     * Liste des articles
     */
    getInventaires({commit}) {
        api.inventaires().then(
            response => {
                commit('SET_INVENTAIRES', response)
            }
        )
    },


    saveInventaire({dispatch}, data) {
        api.saveInventaire(data).then(
            
            dispatch('getInventaire')
            
        )
    },



}

// mutations
const mutations = {
    
    SET_INVENTAIRES(state,inventaires) {
        state.inventaires = inventaires
    },

    SET_INVENTAIRE(state,inventaire) {
        state.inventaire = inventaire
    },


    SET_RESULTATS(state,resultats) {
        state.resultats = resultats
    },

}

export default {
  state,
  getters,
  actions,
  mutations
}
